import { useEffect } from 'react';
import { Button, notification } from '@nula/core-ui';
import { useRevocationStore } from '@/lib/sharing/stores/use-revocation-store';
import { useNavigateToWorkspaceView } from '@/hooks/navigation';

// Fires a danger notification when the server sends a DELETED event for the
// currently-viewed resource (i.e. access was revoked mid-session). The user
// is navigated home on dismiss or when they click "Go to home".
//
// Mount this once in the App root so it is always reachable regardless of
// which panel/view is active. Despite the name, this is no longer a modal —
// the file name is kept to limit churn; rename as a follow-up.
export function RevocationModal() {
  const revokedResource = useRevocationStore((s) => s.revokedResource);
  const clearRevoked = useRevocationStore((s) => s.clearRevoked);
  const navigateToView = useNavigateToWorkspaceView();

  useEffect(() => {
    if (!revokedResource) return;

    const goHome = () => {
      clearRevoked();
      navigateToView('home');
    };

    const instance = notification.warning({
      message: 'Access revoked',
      description: `Your access to "${revokedResource.title}" was removed.`,
      btn: (
        <Button size="sm" variant="text" onClick={goHome}>
          Go to home
        </Button>
      ),
      duration: 0,
    });

    return () => instance.destroy();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revokedResource]);

  return null;
}
